/**
 * Rewrite go2rtc absolute URLs to same-origin `/go2rtc/...` (webpack/nginx proxy).
 * Keeps MSE WebSocket and WebRTC SDP POST on the page origin (avoids CORS).
 */
export function toSameOriginGo2rtcUrl(url) {
    try {
        const parsed = new URL(url, window.location.href);
        const dockerHost = parsed.hostname === 'host.docker.internal' || parsed.hostname === 'go2rtc';
        if (parsed.port === '1984' || /:(1984)\b/.test(parsed.host) || dockerHost) {
            return `/go2rtc${parsed.pathname}${parsed.search}`;
        }
    }
    catch (_a) {
        // keep original
    }
    return url;
}
/**
 * Parse MEDIA_WEBRTC_ICE_URLS=stun:host:port,stun:host2:port → RTCIceServer[]
 * Empty → [] (LAN / same-host only).
 */
export function parseIceServers(raw) {
    const urls = String(raw || '')
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean);
    if (!urls.length) {
        return [];
    }
    return [{ urls }];
}
